/**
 * TALEP DURUM KUMELERI — sekme parametrelerinin TEK kaynagi.
 *
 * Sunucudaki durum makinesi: services/dovizhub-currency-management/.../task-status.js.
 * Kabulden sonra iki adimli buro onayi (2026-09-26):
 *
 *   pending          musteri teklifi onayladi, ODEMESI bekleniyor       (15 dk, faz 'payment')
 *   payment_received buro "Odeme alindi" dedi, GONDERIMI bekleniyor     (15 dk, faz 'payment')
 *   completed        buro "Islemi tamamla" dedi
 *
 * ============================ NEDEN IKI KUME ===============================
 * Onaylanan ve Gecmis sekmeleri eskiden BIRBIRINDEN BAGIMSIZ yaziliyordu: Onaylanan
 * `taskStatus: 'pending,warning'`, Gecmis yalniz `passedTasks: 'passive'`. Iki sonuc:
 *   - 'warning' SON durum (platform yonetimi cozer) ama Onaylanan'da gunlerce birikiyordu.
 *   - Odeme penceresi dolmus 'pending' is (faz 'passive') AYNI ANDA iki sekmede gorunuyordu.
 * Artik iki kume AYRIK ve birlesimleri tum durum listesi (src/lib/__tests__/task-status.test.ts);
 * aktif bir durum iki sekmede birden gorunemez.
 *
 * 'new' KAPALI kumede: karar penceresi dolmus bir 'new' talep, supurucu onu 'expired' /
 * 'no_offers'a cekene kadar faz 'passive' ile gelir ve Gecmis'te gorunmeli.
 * 'active' (seed'de var, hicbir kod yolu yazmiyor) bilincli olarak iki kumede de yok.
 */

/** Kabul edilmis ve henuz kapanmamis is — iki adimin ikisi de 15 dakikalik 'payment' fazinda. */
export const ACTIVE_ACCEPTED_STATUSES = ['pending', 'payment_received'] as const;
export type ActiveAcceptedStatus = (typeof ACTIVE_ACCEPTED_STATUSES)[number];

/** Gecmis sekmelerinin durum listesi (faz 'passive' ile birlikte gonderilir). */
export const CLOSED_TASK_STATUSES = [
  'new',
  'completed',
  'cancelled',
  'warning',
  'expired',
  'no_offers',
  'resolved',
  'refunded',
] as const;
export type ClosedTaskStatus = (typeof CLOSED_TASK_STATUSES)[number];

/**
 * Durum 'payment' zincirinde mi? Sunucudaki PAYMENT_PHASE_STATUSES (db-scripts.js) ile AYNI
 * kume: faz hesabi (lib/task-phase.ts) ve musterinin uyari penceresi bunu kullanir.
 */
export const isActiveAcceptedStatus = (
  code: string | null | undefined,
): code is ActiveAcceptedStatus =>
  typeof code === 'string' && (ACTIVE_ACCEPTED_STATUSES as readonly string[]).includes(code);

/**
 * Gecmis sekmelerinin ORTAK sunucu parametresi: kapali faz + kapali durum.
 *
 * Yalniz `passedTasks: 'passive'` YETMIYOR: odeme/gonderim penceresi dolmus 'pending' ve
 * 'payment_received' da 'passive' fazinda gelir ama is hala ayakta (uyari bekliyor ya da
 * buro onayi bekliyor). Durum listesi onlari Gecmis'ten ayiriyor.
 */
export const CLOSED_LIST_PARAMS: Readonly<Record<string, string>> = Object.freeze({
  passedTasks: 'passive',
  taskStatus: CLOSED_TASK_STATUSES.join(','),
});
